import React, { useCallback, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  currAsOfDateFieldName,
  showpublicFieldName,
  view,
} from "../../../../utils/API";
import { ConfigContext } from "../../../../utils/ConfigContext";
import { EditorContext } from "../../Editor/EditorContextProvider";
import CycleManagerBatchUpdate from "../CycleManagerBatchUpdate/CycleManagerBatchUpdate";
import ChecklistHeader from "./ChecklistHeader/ChecklistHeader";
import ChecklistTable from "./ChecklistTable";

import ChecklistSidebar from "./CheckListSidebar/ChecklistSidebar";

import { useTranslation } from "react-i18next";
import useLayerEditTable from "../../../../hooks/LayerEditTable";
import { setActiveModule } from "../../../../redux/action/ActiveModule-actions";
import { MessagesOverlay } from "../../../LayerTable/LayerEditTable";
import {
  getFeatureNameField,
  getFeatureNameFields,
  getSituationalBatchFields,
} from "../../Editor/helpers";

const Checklist = ({
  layers,
  editedFeatures,
  setEditedFeatures,
  openSnackbar,
  handleClose,
  closeCycleManager,
  setShowCloseMessage,
  showCloseMessage,
}) => {
  const {
    editableLayer,
    setEditableLayer,
    setBatchUpdateFeatures,
    batchUpdateFeatures,
  } = useContext(EditorContext);
  const { cycleUpdateDueDate, lastCycleUpdate } = useSelector(
    (state) => state.cycleManagerReducer
  );
  const activeModule = useSelector((state) => state.activeModule);
  const { config } = useContext(ConfigContext);

  const { t } = useTranslation("common");
  const [saved, setSaved] = useState(false);
  const [query, setQuery] = useState(null);

  const {
    onRowDataUpdated,
    handleUpdateAll,
    onBatchUpdateSave,
    handleLayerSelection,
    toggleBatchUpdate,
    updateFeaturesIds,
    graphicsLayer,
    updatedFeatures,
    showUpdateMessage,
    requiredFieldsMessage,
    setSaveMessage,
    saveMessage,
    showBatchUpdate,
    gridApi,
    setGridApi,
    setFeatures,
    features,
    loading,
  } = useLayerEditTable({
    editableLayer,
    setEditableLayer,
    setBatchUpdateFeatures,
    batchUpdateFeatures,
    editedFeatures,
    setEditedFeatures,
    updateType: "situational",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (layers.length > 0 && !editableLayer) {
      const moduleLayers = config.modules[activeModule]?.layers || [];
      let firstModuleLayer = layers
        .filter((l) =>
          moduleLayers.includes(l.layerConfig?.alias || l.layerConfig?.extends)
        )
        .toArray()[0];

      layers.map((layer) => {
        const layerConfig = layer.layerConfig;

        if (
          layerConfig &&
          moduleLayers.includes(layerConfig.extends || layerConfig.alias) &&
          !firstModuleLayer
        ) {
          firstModuleLayer = layer;
        }
      });
      setEditableLayer(firstModuleLayer);
    }
  }, [layers]);

  const generateQueryFields = useCallback(
    (editableLayer) => {
      if (!editableLayer) return [];
      const newSituationalFields = getSituationalBatchFields({
        editableLayer: editableLayer,
        config,
      });

      const name = getFeatureNameField(editableLayer);
      const names = getFeatureNameFields(editableLayer);
      const nameFields = editableLayer.fields.filter((f) =>
        names.includes(f.name)
      );

      const showPublic = editableLayer.fields.find(
        (f) => f.name === showpublicFieldName
      );

      const currAsOfDateField = editableLayer.fields.find(
        (f) => f.name === currAsOfDateFieldName
      );

      if (
        !newSituationalFields.some((f) => f.name === currAsOfDateFieldName) &&
        currAsOfDateField
      ) {
        newSituationalFields.push(currAsOfDateField);
      }

      if (
        !newSituationalFields.some((f) => f.name === showpublicFieldName) &&
        showPublic
      ) {
        newSituationalFields.unshift(showPublic);
      }

      if (
        nameFields.length > 0 &&
        newSituationalFields.filter((f) => names.includes(f.name)).length === 0
      ) {
        nameFields.forEach((field) => {
          newSituationalFields.push(field);
        });
      }

      // Sort - date field goes last
      newSituationalFields.sort((a, b) => {
        if (names.includes(a.name)) return -1;
        if (names.includes(b.name)) return 1;
        if (a.name === currAsOfDateFieldName) return 1;
        if (b.name === currAsOfDateFieldName) return -1;
        return 0;
      });

      return newSituationalFields;
    },
    [config]
  );

  return (
    <>
      {editableLayer && showBatchUpdate && (
        <CycleManagerBatchUpdate
          isCheckList={true}
          openSnackbar={openSnackbar}
          handlePrev={toggleBatchUpdate}
          onSave={onBatchUpdateSave}
        />
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <ChecklistSidebar
          editableLayer={editableLayer}
          layers={layers}
          onLayerSelect={handleLayerSelection}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            flex: 1,
            position: "relative",
          }}
        >
          <ChecklistHeader
            editedFeatures={editedFeatures}
            toggleBatchUpdate={toggleBatchUpdate}
            handleUpdateAll={handleUpdateAll}
            handleClose={() => {
              handleClose();
              view.map.remove(graphicsLayer);
            }}
            confirmUpdateCount={showBatchUpdate ? 0 : updateFeaturesIds.length}
            saveEnabled={Object.keys(editedFeatures).length > 0}
          />
          <div style={{ flex: 1, position: "relative" }}>
            {/* {showBatchUpdate && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "#eeeeeed4",
                  zIndex: 2,
                }}
              ></div>
            )}
            {requiredFieldsMessage.show && (
              <Message
                position="absolute"
                title={t("cycleManager.saveMessages.missingFields", { 1: "" })}
                subtitle={
                  <span
                    style={{
                      fontWeight: 400,
                      fontSize: "inherit",
                      color: "red",
                    }}
                  >
                    {requiredFieldsMessage.fields.join(", ")}
                  </span>
                }
              />
            )}
            {saveMessage.show && (
              <Message
                position="absolute"
                title={t("cycleManager.areYouSure.defaultTitle")}
                subtitle={t("cycleManager.areYouSure.unsavedChanges")}
                onSubmit={() => {
                  if (saveMessage.newModule) {
                    dispatch(setActiveModule(saveMessage.newModule));
                  }
                  setEditableLayer(saveMessage.newLayer);
                  setSaveMessage({
                    show: false,
                    newLayer: null,
                  });
                }}
                onCancel={() => {
                  setSaveMessage({
                    show: false,
                    newLayer: null,
                  });
                }}
                confirmText="Save"
                color={config.opsColor}
              />
            )}
            {showCloseMessage && (
              <Message
                position="absolute"
                title={t("cycleManager.areYouSure.closeTitle")}
                subtitle={t("cycleManager.areYouSure.unsavedChanges")}
                onSubmit={() => {
                  closeCycleManager();
                  view.map.remove(graphicsLayer);
                }}
                onCancel={() => {
                  setShowCloseMessage(false);
                }}
                color={config.opsColor}
              />
            )}
            {showUpdateMessage && (
              <SaveMessage
                updateType={UpdateType.situational}
                color={config.opsColor}
                editType={EditType.edit}
                actionType="updated"
                position="absolute"
                updatedFeatures={updatedFeatures}
              />
            )} */}
            <MessagesOverlay
              batchUpdateFeatures={batchUpdateFeatures}
              editableLayer={editableLayer}
              activeColor={config.opsColor}
              showBatchUpdate={showBatchUpdate}
              requiredFieldsMessage={requiredFieldsMessage}
              saveMessage={saveMessage}
              onCloseMessageCancel={() => {
                setShowCloseMessage(false);
              }}
              showCloseMessage={showCloseMessage}
              updatedFeatures={updatedFeatures}
              showUpdateMessage={showUpdateMessage}
              onCloseMessageSubmit={() => {
                closeCycleManager();
                view.map.remove(graphicsLayer);
              }}
              onSaveMessageSubmit={() => {
                if (saveMessage.newModule) {
                  dispatch(setActiveModule(saveMessage.newModule));
                }
                setEditableLayer(saveMessage.newLayer);
                setSaveMessage({
                  show: false,
                  newLayer: null,
                });
              }}
              onSaveMessageCancel={() => {
                setSaveMessage({
                  show: false,
                  newLayer: null,
                });
              }}
            />
            {editableLayer &&
              cycleUpdateDueDate &&
              lastCycleUpdate &&
              graphicsLayer && (
                <ChecklistTable
                  layer={editableLayer}
                  generateQueryFields={generateQueryFields}
                  editedFeatures={editedFeatures}
                  setEditedFeatures={setEditedFeatures}
                  loading={loading}
                  gridApi={gridApi}
                  setGridApi={setGridApi}
                  setFeatures={setFeatures}
                  features={features}
                  onRowDataUpdated={onRowDataUpdated}
                  graphicsLayer={graphicsLayer}
                  openSnackbar={openSnackbar}
                  batchUpdateFeatures={batchUpdateFeatures}
                />
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Checklist;
